/**
 * OVERRIDE SummaryTemplate.jsx
 * REASON:
 */

import SummaryTemplate from '../../../../../../components/Blocks/Listings/SummaryTemplate';

export default SummaryTemplate;
